import React from 'react';
import './Loader.css';

const Loader = (props) => (
	<div className='white-backdrop'>
    <p>Carregando...</p>
  </div>
);

export default Loader;